import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from 'src/app/service/navigation.service';

@Component({
	selector: 'app-portal-menu-mobile',
	templateUrl: './portal-menu-mobile.component.html',
	styleUrls: ['./portal-menu-mobile.component.css']
})
export class PortalMenuMobileComponent implements OnInit {

	@Output() onMenuChange: EventEmitter<boolean> = new EventEmitter();

	constructor(
		private navigate: NavigationService,
		private router: Router
	) {
	}

	/** Pagina actual para resaltarla en el menu ('home', 'about-us', 'insured') */
	isActive(key: string): boolean {
		const u = (this.router.url || '/').split(/[?#]/)[0];
		if (key === 'home') { return u === '/' || u === ''; }
		return u === '/' + key || u.startsWith('/' + key + '/');
	}

	goPrivacy() {
		this.router.navigate(['/privacy-policy'])
		this.menuChange()
	}

  	goHome() {
		this.navigate.navigateToHome()
		this.menuChange()
	}

	goAboutUs() {
		this.navigate.navigateToAbout()
		this.menuChange()
	}

	goBlog() {
		this.navigate.navigateToBlog()
		this.menuChange()
	}

	goQuote() {
		this.navigate.navigateToQuote()
		this.menuChange()
	}

	goBenefits() {
		this.navigate.navigateToBenefits()
		this.menuChange()
	}

	goInsured() {
		this.navigate.navigateToInsured()
		this.menuChange()
	}

	goPortalLogin() {
		window.location.href = 'https://blue.portal.wemarkforyou.com/'
	}

	menuChange(){
		var el =  document.getElementById('menuHambur')
		el.click()
	}

	ngOnInit() {
	}


}
